module.exports = __webpack_public_path__ + "img/R6__1230.7a526378.jpeg";